import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes, useLocation } from "react-router";

import { NotFoundBoard } from "@/components/Chrome";
import AdminPage from "@/pages/Admin";
import BoardingPage from "@/pages/Boarding";
import CheckinPage from "@/pages/Checkin";
import DeparturesPage from "@/pages/Departures";
import FlightPage from "@/pages/Flight";
import ManifestPage from "@/pages/Manifest";
import PassPage from "@/pages/Pass";
import SeatPage from "@/pages/Seat";
import "./globals.css";

/** 換頁時捲回頂端 —— SPA 不會像多頁式那樣自動重置捲動位置 */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function NotFound() {
  const { pathname } = useLocation();
  return (
    <main className="mx-auto max-w-xl px-4 py-10">
      <NotFoundBoard message={`沒有這個頁面：${pathname}`} />
    </main>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<DeparturesPage />} />
        <Route path="/flight/:code" element={<FlightPage />} />
        <Route path="/flight/:code/checkin" element={<CheckinPage />} />
        <Route path="/flight/:code/seat" element={<SeatPage />} />
        <Route path="/pass/:token" element={<PassPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/:code" element={<ManifestPage />} />
        <Route path="/admin/:code/boarding" element={<BoardingPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
